import { render, staticRenderFns } from "./header-checkout.vue?vue&type=template&id=549cc98e&scoped=true&"
import script from "./header-checkout.vue?vue&type=script&lang=js&"
export * from "./header-checkout.vue?vue&type=script&lang=js&"
import style0 from "./header-checkout.vue?vue&type=style&index=0&id=549cc98e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549cc98e",
  null
  
)

export default component.exports